import React from 'react'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import { CardWithHeader } from 'ui'
import ChecklistActivity from '../../../support/displays/ChecklistActivity'
import ChecklistProgress from '../../../support/displays/ChecklistProgress'
import { ChecklistName } from 'support/displays/ChecklistName'
import * as Displays from 'support/displays'
import { CardGroup } from '../../../ui'
import { PaginationFilter } from '@morningtrain/react-filters'
import OnClickTableRow from 'widgets/crud/OnClickTableRow'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function ChecklistListView () {
  const [, setFocusedChecklist] = useEnvValue('checklist.focused_list', null)

  const editChecklist = (model, id) => {
    setFocusedChecklist(id)
  }

  return (
    <CardGroup>
      <PaginationFilter />
      <ForEachModel>
        <CardWithHeader header={<Displays.Enum name='key' enum='employment_type_category' />}>
          <Translator namespace='checklists.columns'>
            <ValueToCollection name='collection'>
              <Table row={<OnClickTableRow callback={editChecklist} />}>
                <Columns.Text
                  name='list'
                  label={<Translation name='list' />}
                  display={<ChecklistName />}
                  className='w-64'
                />
                <Columns.DateTime
                  name='fill_at'
                  label={<Translation name='fill_at' />}
                  className='w-64'
                />
                <Columns.Text
                  name='activity'
                  label={<Translation name='activity' />}
                  display={<ChecklistActivity />}
                  className='w-64'
                />
                <Columns.Text
                  name='progress'
                  label={<Translation name='progress' />}
                  display={<ChecklistProgress />}
                  className='w-64'
                />
              </Table>
            </ValueToCollection>
          </Translator>
        </CardWithHeader>
      </ForEachModel>
    </CardGroup>
  )
}
